import React from "react";
import { Explore } from "@/components/Explore";
import { Hero } from "@/components/Hero";
import { FeaturedSpots } from "@/components/FeaturedSpots";
import { useSections } from "@/lib/sections";

export default function CustomerHome() {
  const s = useSections();
  return (
    <div className="space-y-10" data-testid="customer-home-page">
      <Hero showPartner={false} />
      {s.mode && s.spots && <FeaturedSpots />}
      {s.mode && s.events && <Explore />}
    </div>
  );
}
